import { createContext, ReactNode, useContext } from "react";

export interface InsightMetaActions {
  saveDescription: (text: string) => Promise<void>;
  updateDescription: () => Promise<string | undefined>;
}

export const InsightMetaContext = createContext<InsightMetaActions | undefined>(
  undefined
);

export const useInsightMeta = () => {
  const context = useContext(InsightMetaContext);
  if (!context) {
    throw new Error("useInsightMeta must be used within the context");
  }
  return context;
};

interface InsightMetaProps {
  children: ReactNode;
  handleUpdateDescription: (text: string) => Promise<void>;
  handleRefreshDescription: () => Promise<string | undefined>;
}

export const InsightMetaProvider = ({
  children,
  handleUpdateDescription,
  handleRefreshDescription,
}: InsightMetaProps) => {
  const saveDescription = async (text: string) => {
    await handleUpdateDescription(text);
  };

  const updateDescription = async () => {
    return await handleRefreshDescription();
  };

  const value: InsightMetaActions = {
    saveDescription,
    updateDescription,
  };

  return (
    <InsightMetaContext.Provider value={value}>
      {children}
    </InsightMetaContext.Provider>
  );
};
